import React, { useState, useEffect } from 'react'
import { Link } from "react-router-dom";
import { ArrowBackIcon } from "~/Components/Icons/Icons";
import { adminHttp } from "~/Admin/services/http";

const AdminViewTranslation = ({ match, ...props }) => {

    const [translation, setTranslation] = useState(null);
    const [languages, setLanguages] = useState([]);

    const [form, setForm] = useState({});

    const [error, setError] = useState(null);
    const [message, setMessage] = useState('');


    const handleChange = (lang_id, e) => {
        const value = e.target.value;

        setForm({ ...form, [lang_id]: value });
    };

    const endpoint = '/translations/' + match.params.id;

    const loadData = () => {
        adminHttp
            .get(endpoint)
            .then(res => {

                setTranslation(res.data);

                const form = {};

                res.data.translation_values.forEach(val => {
                    form[val.language_id] = val.value;
                });

                setForm(form);
            });
    };


    const handleSubmit = () => {
        adminHttp
            .post(endpoint, form)
            .then(res => {
                setError(null);
                setMessage('Saved successfully!');

            }).catch((error) => {
                setMessage(null);
                setError(error.response?.data);
            });
    };

    const loadLanguages = () => {
        adminHttp
            .get('/languages',)
            .then(res => setLanguages(res.data.data));
    };

    useEffect(loadData, []);
    useEffect(loadLanguages, []);

    return (
        <div>
            <Link to="/multilang" className="btn btn-secondary btn-sm mb-4">
                <ArrowBackIcon classes="d-inline mr-2" />
                Back
            </Link>

            <div className="row">
                <div className="col-6">
                    <h2>
                        <b>Section: </b>{translation?.translation_section?.name}
                    </h2>
                    <h2>
                        <b>Category: </b>{translation?.category}
                    </h2>
                    <h2>
                        <b>Name: </b>{translation?.name}
                    </h2>
                </div>
            </div>

            <div className="card shadow-sm bg-white mt-3">
                <div className="card-body">
                    {message && (
                        <div className="alert alert-success" role="alert">
                            {message}
                        </div>
                    )}

                    {error && (
                        <div className="alert alert-danger" role="alert">
                            {error.message || "Error saving event!"}
                        </div>
                    )}

                    <table className="table">
                        <thead>
                            <tr>
                                <th>Language</th>
                                <th>Translation</th>
                            </tr>
                        </thead>
                        <tbody>
                            {languages.map(lang => (
                                <tr>
                                    <td>{lang.name}</td>
                                    <td>
                                        <textarea
                                            defaultValue={form[lang.id]}
                                            onChange={e => handleChange(lang.id, e)}
                                            className="form-control" />
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <button
                        onClick={handleSubmit}
                        className="btn btn-primary text-cta float-right btn-sm align-self-end">
                        Save
                    </button>
                </div>
            </div>
        </div>
    );
}

export default AdminViewTranslation;
